var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconFlightTravel128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.2064 48.9117L91.3865 52.1453C92.1606 52.9324 92.3694 54.1153 91.9116 55.1198L88.3935 62.8373L99.8438 98.7043C100.737 101.504 99.7725 105.462 97.6992 107.535L96.975 108.26C94.897 110.338 92.0629 109.932 90.6479 107.358L67.8023 65.8092L80.3086 55.855L88.2064 48.9117Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9976 39.0352L72.2342 43.7998C72.1482 43.9347 72.0423 44.0691 71.9161 44.2011L58.6738 58.0462L19.0394 37.0246C16.4451 35.6486 16.0225 32.8442 18.1024 30.7643L18.8273 30.0394C20.9024 27.9643 24.8738 26.9862 27.687 27.8654L63.3427 39.0075L70.9111 35.7759C71.8441 35.3774 72.9224 35.543 73.6927 36.2031L76.9976 39.0352Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.319 18.4576C112.201 22.3395 112.201 28.6334 108.319 32.5153C108.254 32.5804 108.188 32.6447 108.121 32.7079L56.1787 81.8396L54.5054 83.512L61.8161 108.322L59.4168 110.721C57.3398 112.799 54.5724 112.367 53.2299 109.747L41.2617 86.3854L40.3909 85.5146L17.029 73.5464C14.486 72.2434 14.005 69.5981 15.8781 67.5445L16.0548 67.3595L18.4541 64.9602L43.2634 72.2701L44.9916 70.5427L94.0685 18.6559C97.8409 14.6675 104.132 14.4925 108.12 18.2648C108.187 18.3281 108.254 18.3924 108.319 18.4576Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconFlightTravel128);
export default __webpack_public_path__ + "static/media/pictogramBeaconFlightTravel128.ac3b041db7631039c09550e3570e1def.svg";
export { ForwardRef as ReactComponent };